export default __webpack_public_path__ + "static/media/download-csv.f0ca9731.svg";